import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import Basic from './Basic';
import Directions from './Direction';
import HtmlElement from './HtmlElement';
import Offset from './Offset';

const TooltipsContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='Tooltip' parent='Ui Kits' title='Tooltip' />
      <Row>
        <Basic />
        <Directions />
        <HtmlElement />
        <Offset />
      </Row>
    </Container>
  );
};

export default TooltipsContainer;
